// src/admin/RequireAdmin.js
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

export default function RequireAdmin({ children }) {
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAdmin(false);
        setChecking(false);
        return;
      }

      try {
        const userRef = doc(db, "users", user.uid);
        const snap = await getDoc(userRef);

        const role = snap.exists() ? snap.data().role : "user";

        if (role === "admin") {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } catch (err) {
        console.error("Error checking admin role:", err);
        setIsAdmin(false);
      } finally {
        setChecking(false);
      }
    });

    return () => unsub();
  }, []);

  if (checking) {
    return (
      <div style={{ padding: "40px", textAlign: "center", color: "#fff" }}>
        Checking admin access…
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div
        style={{
          padding: "60px 20px",
          maxWidth: "600px",
          margin: "0 auto",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <h2>Access denied</h2>
        <p style={{ marginTop: "10px", color: "#bbb" }}>
          You must be an administrator to view this page.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
